<!-- 资料详情-查看图片 -->
<template>
  <div>
    <div
      class="register"
      :style="{width: fullWidth+'px', height:fullHeight+'px'}"
    >
      <div
        class="img_box"
        :style="{width: fullWidth+'px','background-image': 'url('+img+')'}"
      ></div>
    </div>

    <div class="downWrapper">
      <van-button
        type="default"
        class="see"
        :to="'InfoDetails?pageId='+pageId"
      >查看更多</van-button>
      <van-button
        type="primary"
        @click="download"
      >下载 </van-button>
    </div>

    <!-- 资料下载弹框 -->
    <DataPopup :dataPopup="dataPopup" />
  </div>

</template>

<script>
import DataPopup from "@/components/DataPopup.vue";
export default {
  data() {
    return {
      fullWidth: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      img: this.$route.query.fileUrl,
      dataPopup: false,
      pageId: this.$route.query.pageId,
      fileId: this.$route.query.fileId,
    };
  },
  components: {
    DataPopup,
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    let iphoneNum = localStorage.getItem("iphoneNum");
    // 如果没有填过就弹框
    if (!iphoneNum) {
      this.dataPopup = true;
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    download() {
      if (this.$route.query.fileUrl) {
         window.location.href = this.downloadUrl + this.fileId;
        // this.downloadFile(
        //   this.$route.query.fileUrl,
        //   this.$route.query.fileName
        // );
      }
    },
    handleResize() {
      this.fullWidth = document.documentElement.clientWidth;
      this.fullHeight = document.documentElement.clientHeight;
    },
  },
};
</script>
<style scoped>
.register {
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  background: #000;
}
.register .img_box {
  position: absolute;
  background-size: contain;
  background-repeat: no-repeat;
  /* 保证盒子始终在窗口中心 */
  background-position: center center;
  /* 避免窗口周围留白 */
  width: 100%;
  height: 100%;
}
</style>